var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilderGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E7F0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 8.68851 15.3115 6 12 6C8.68851 6 6 8.68851 6 12C6 15.3115 8.68851 18 12 18C15.3115 18 18 15.3115 18 12ZM4 12C4 7.58468 7.58468 4 12 4C16.4153 4 20 7.58468 20 12C20 16.4153 16.4153 20 12 20C7.58468 20 4 16.4153 4 12ZM12 14.5C13.3798 14.5 14.5 13.3798 14.5 12C14.5 10.6202 13.3798 9.5 12 9.5C10.6202 9.5 9.5 10.6202 9.5 12C9.5 13.3798 10.6202 14.5 12 14.5ZM12 7.5C14.4836 7.5 16.5 9.51638 16.5 12C16.5 14.4836 14.4836 16.5 12 16.5C9.51638 16.5 7.5 14.4836 7.5 12C7.5 9.51638 9.51638 7.5 12 7.5ZM11 12C11 11.4481 11.4481 11 12 11C12.5519 11 13 11.4481 13 12C13 12.5519 12.5519 13 12 13C11.4481 13 11 12.5519 11 12Z",
    fill: "#0C66E4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderGoal);
export default __webpack_public_path__ + "static/media/builderGoal.2e32b7d669919b54ecb139d8c1ade0c6.svg";
export { ForwardRef as ReactComponent };